import { Nav } from "react-bootstrap";
import "./PrivacyTab.css";
import {
  AllReturnPolicy,
  AllReturnPolicyContent,
} from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const privacySections = [
  { id: "1", title: "Information We Collect" },
  { id: "2", title: "How We Use Information" },
  { id: "3", title: "Sharing of Information" },
  { id: "4", title: "Data Security" },
  { id: "5", title: "Cookies & Tracking Technologies" },
  { id: "6", title: "User Rights" },
  { id: "7", title: "Children’s Privacy" },
];

function PrivacySidebar({ activeTab, setActiveTab }) {
  const dispatch = useDispatch();

  const all_return_policy_content = useSelector(
    (state) => state?.common?.all_return_policy_content,
  );
  // const all_privacy_policy = useSelector(
  //   (state) => state?.common?.all_privacy_policy,
  // );

  useEffect(() => {
    dispatch(AllReturnPolicyContent());
    // dispatch(AllPrivacyPolicy());
  }, [dispatch]);

  const handleSelect = (selectedKey) => {
    setActiveTab(selectedKey);

    const element = document.getElementById(selectedKey);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Nav
      className=" privacy-nav px-4"
      activeKey={activeTab}
      onSelect={handleSelect}
    >
      <h5>Content Of Table</h5>

      {all_return_policy_content?.map((item) => (
        <Nav.Link key={item?.id} eventKey={item?.id}>
          {item?.id}. {item?.name}
        </Nav.Link>
      ))}
    </Nav>
  );
}

export default PrivacySidebar;
